// Minimal SkioBoxChildProducts component
import { LitElement, html, css } from "https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";

const boxChildStyles = css`
  :host {
    position: relative;
  }
  .skio-box-child-grid {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 2rem 0;
    z-index: 0;

    
  }

  .skio-box-child-card {
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 1rem;
    text-align: center;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.03);
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .skio-box-child-card img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 1rem;
  }
  .skio-box-child-card-variant-title {
    font-size: 0.8rem;
  }
  .skio-box-child-card label {
    display: flex;
    align-items: center;
  }

  .skio-box-child-card button,
  .skio-box-child-card input[type="number"] {
    width: 40px;
    height: 40px;
    border: 1px solid #eee;
    background: #fff;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 600;
    color: #222;
    text-align: center;
  }

  .skio-box-child-card button {
    height: 42px;
    width: 42px;
  }

  .skio-box-child-card button:first-of-type {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
  }

  .skio-box-child-card button:last-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
  }

  .skio-box-child-card input[type="number"] {
    border-radius: 0;
    border-left: none;
    border-right: none;
    height: 40px;
    padding: 0;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .skio-box-progress-bar-wrapper {
    position: sticky;
    padding-top: 20px;
    background-color: #fff;
  }
  .skio-box-progress-bar-container {
    width: 100%;
    max-width: 100%;
    margin: 0 auto 1.5rem auto;
    background: rgba(191, 96, 89, 0.5);
    border-radius: 0;
    height: 34px;
    position: relative;
  
    position: sticky;
  }
  .skio-box-progress-bar {
    height: 100%;
    background: #bf6059;
    border-radius: 0;
    transition: width 0.3s;
    cursor: not-allowed;
    opacity: 0.7;
  }
  .skio-box-progress-bar.clickable {
    cursor: pointer;
    opacity: 1;
    box-shadow: 0 0 0 2px #bf6059;
  }
  .skio-box-progress-label {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: 400;
    color: #fff;
    z-index: 2;
    pointer-events: none;
    text-transform: uppercase;

    font-family: "brandon-grotesque", sans-serif;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1.5px;
    line-height: 32px;
  }

  
`;

export class SkioBoxChildProducts extends LitElement {
  static styles = boxChildStyles;
  static properties = {
    product: { type: Object },
    productHandle: { type: String },
    variantId: { type: String },
    childProducts: { state: true },
    loading: { state: true },
    error: { state: true },
    selectedVariants: { state: true },
    selectedVariant: { type: Object },
    maxQuantity: { state: true },
  };

  constructor() {
    super();
    this.product = null;
    this.productHandle = '';
    this.variantId = '';
    this.childProducts = [];
    this.loading = false;
    this.error = '';
    this.selectedVariants = {};
    this.selectedVariant = null;
    this.maxQuantity = 0;
    this._onVariantChange = this._onVariantChange.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    this._initProduct().then(() => {
      this._fetchChildProducts();
      this._setupVariantListeners();
      this._setupFormIntegration();
    });
    document.addEventListener('variant:change', this._onVariantChange);
  }

  addStickyStyles() {
    // Wait for the progress bar element to exist in the component's shadow DOM
    const waitForProgressBar = () => {
      const progressBar = this.shadowRoot.querySelector('.skio-box-progress-bar-wrapper');
      
      if (!progressBar) {
        // If element doesn't exist, check again after a short delay
        setTimeout(waitForProgressBar, 200);
        return;
      }
      
      // Now that we have the progress bar element, proceed with positioning
      const variantSelects = document.querySelector('variant-selects');
      const skioPlanPicker = document.querySelector('skio-plan-picker');
      
      if (variantSelects) {
        const variantSelectsHeight = variantSelects.offsetHeight;
        let totalHeight = 100 + variantSelectsHeight;
        
        // Position skio-plan-picker if it exists
        if (skioPlanPicker) {
          const skioPlanPickerHeight = skioPlanPicker.offsetHeight;
          skioPlanPicker.style.top = totalHeight + 'px';
          totalHeight += skioPlanPickerHeight;
        }
        
        // Position progress bar based on whether skio-plan-picker exists
        progressBar.style.top = totalHeight + 'px';
      }
    };
    
    // Start checking for the element after a short delay
    setTimeout(waitForProgressBar, 500);

    const style = document.createElement('style');
    style.textContent = `
        variant-selects {
          position: sticky;
          top: 105px;
          z-index: 2;
          background-color: #fff;
        }
        skio-plan-picker {
          position: sticky;
          z-index: 2;
          background-color: #fff;
        }
        .product-add-to-cart-wrapper {
          display: none;
        }

        variant-selects>div, .product-add-to-cart-wrapper>.product-form {
          background-color: #fff;
        }
        
        .product-add-to-cart-wrapper>.product-form {
          margin-top: 0;
        }

      .variations fieldset legend.form__label,
      .group-title {
        font-family: 'avenir', sans-serif;
        font-weight: 400;
        font-size: 16px;
        letter-spacing: 0.02em;
      }

      .variations fieldset .select select {
        font-family: "brandon-grotesque", sans-serif;
        background-color: white !important;
        border-color: #241F20 !important;
        border-radius: 0 !important;
        color: #241F20 !important;
        font-family: "brandon-grotesque", sans-serif;
        font-weight: 600 !important;
        height: 34px;
        letter-spacing: 1px;
        line-height: 34px;
        padding-bottom: 0px !important;
        padding-left: 13px !important;
        padding-right: 36px !important;
        padding-top: 0 !important;
        text-align: left !important;
        text-transform: uppercase !important;
        background-image: url(data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10.721 5.701'><path d='M10.121.6,5.585,5.01a.323.323,0,0,1-.449,0L.6.6' fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.2'/></svg>);
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 11px;
        min-width: 150px;
        width: 100%;
      }
    `;
    document.head.appendChild(style);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('variant:change', this._onVariantChange);
  }

  async _initProduct() {
    if (this.product) {
      // If product is already provided
      this.variantId = this.product.variants?.[0]?.id || '';
    } else if (this.productHandle) {
      // Fetch product JSON from Shopify
      try {
        const res = await fetch(`/products/${this.productHandle}.js`);
        if (!res.ok) throw new Error('Failed to fetch product');
        this.product = await res.json();
        this.variantId = this.product.variants?.[0]?.id || '';
      } catch (e) {
        this.error = e.message;
      }
    }
  }

  async _fetchChildProducts() {
    if (!this.variantId) return;
    this.loading = true;
    this.error = '';
    try {
      const res = await fetch('https://api.skio.com/storefront-http/get-classic-box-v2', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productVariantPlatformId: this.variantId }),
      });
      const data = await res.json();
      if (!res.ok || !data.ClassicBoxV2) throw new Error('Failed to fetch child products');
      this.childProducts = data.ClassicBoxV2.selectableProductVariants || [];
    } catch (e) {
      this.error = e.message;
      this.childProducts = [];
    } finally {
      this.loading = false;
    }
  }

  _onVariantChange(e) {
    // Shopify's variant:change event (theme dependent)
    const variant = e.detail?.variant;
    if (variant && variant.id && variant.id !== this.variantId) {
      this.variantId = variant.id;
      this.selectedVariants = {}; // Clear selections
      this._injectHiddenInputs(); // Remove hidden inputs
      this._fetchChildProducts();
    }
  }

  updated(changed) {
    
    if (changed.has('selectedVariant')) {
      this._updateMaxQuantity();
      // After updating maxQuantity, check if we need to clear selections
      const totalSelected = Object.values(this.selectedVariants).reduce((sum, q) => sum + q, 0);
      if (!this.maxQuantity || isNaN(this.maxQuantity) || totalSelected > this.maxQuantity) {
        this.selectedVariants = {};
        this._injectHiddenInputs();
      }
      setTimeout(() => {
        this._updateAddToCartButtonState(); // Disable button after DOM updates
      }, 800);
    }
    
    // Call addStickyStyles when child products are loaded and rendered
    if (changed.has('childProducts') && this.childProducts.length > 0) {
      this.addStickyStyles();
    }
    
    this._updateAddToCartButtonState();
  }

  _updateMaxQuantity() {
    if (this.selectedVariant && this.selectedVariant.title) {
      let parsed = parseInt(this.selectedVariant.title, 10);
      if (this.product.handle && this.product.handle.includes('office-coffee-bundle-1')) {
        parsed = Math.floor(parsed / 80);
      }
      this.maxQuantity = isNaN(parsed) ? 0 : parsed;
    } else {
      this.maxQuantity = 0;
    }
  }

  _onQuantityChange(e, child) {
    const value = parseInt(e.target.value, 10);
    const variantId = child.platformId || child.id;
    if (value > 0) {
      this.selectedVariants = { ...this.selectedVariants, [variantId]: value };
    } else {
      // Remove if value is 0 or less
      const updated = { ...this.selectedVariants };
      delete updated[variantId];
      this.selectedVariants = updated;
    }
    this._injectHiddenInputs();
  }

  _changeQuantityBy(child, delta) {
    const variantId = child.platformId || child.id;
    const current = this.selectedVariants[variantId] || 0;
    let next = current + delta;
    if (delta > 0 && current === 0) {
      next = 1; // If incrementing from 0, set to 1
    }
    if (next < 0) next = 0;
    // Prevent exceeding max
    const totalSelected = Object.values(this.selectedVariants).reduce((sum, q) => sum + q, 0) - current + next;
    if (this.maxQuantity && totalSelected > this.maxQuantity) {
      next = current; // Don't allow increment if it would exceed max
    }
    const fakeEvent = { target: { value: next } };
    this._onQuantityChange(fakeEvent, child);
    this._injectHiddenInputs();
  }

  _setupVariantListeners() {
    // Try to find the product form and variant input
    let form = this.closest('form') || document.querySelector('form[action*="/cart/add"]');
    let variantInput = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
    if (variantInput && this.product && Array.isArray(this.product.variants)) {
      variantInput.addEventListener('change', e => {
        const variant = this.product.variants.find(v => v.id == e.target.value);
        if (variant) {
          this.selectedVariant = variant;
        }
      });
    }
    // Listen for global variantChanged event (Skio convention)
    document.addEventListener('variantChanged', e => {
      if (!this.product || !Array.isArray(this.product.variants)) return;
      let variantId = e.detail.variantId;
      let variant = this.product.variants.find(x => x.id == variantId);
      if (variant) {
        this.selectedVariant = variant;
      }
    });
  }

  _setupFormIntegration() {
    // Always use the main product form for theme-agnostic support
    this._form = document.querySelector('form[action*="/cart/add"]');
  }

  findProductForm() {
    // First try finding form through parent elements
    const formFromParent = this.findFormThroughParents();
    if (formFromParent) return formFromParent;
    // If no form found through parents, look for any valid product forms on page
    const allProductForms = this.getAllProductForms();
    return allProductForms[0] || null;
  }

  findFormThroughParents() {
    let currentElement = this;
    let depth = 0;
    const maxDepth = 5;
    while (currentElement.parentElement && depth < maxDepth) {
      const forms = Array.from(currentElement.querySelectorAll('form'));
      const validForm = forms.find(form => this.isValidProductForm(form));
      if (validForm) return validForm;
      currentElement = currentElement.parentElement;
      depth++;
    }
    return null;
  }

  getAllProductForms() {
    return Array.from(document.forms).filter(form => {
      const hasVariantId = this.getVariantId(form);
      return this.isValidProductForm(form) && hasVariantId;
    });
  }

  isValidProductForm(form) {
    const hasCartAction = form.getAttribute('action')?.includes('/cart/add');
    const hasSubmitButton = !!form.querySelector('button, [type="submit"]');
    return hasCartAction && hasSubmitButton;
  }

  getVariantId(form) {
    // Try getting ID from FormData first
    const formData = new FormData(form);
    const idFromFormData = formData.get('id');
    if (idFromFormData) return Number(idFromFormData);
    // Fallback to finding input element
    const idInput = form.querySelector('[name="id"]');
    return idInput ? Number(idInput.value) : null;
  }
 
  _injectHiddenInputs() {
    const form = this.findProductForm();
    if (!form) return;
    // Remove any previous hidden inputs for child variants
    Array.from(form.querySelectorAll('input[data-skio-child-variant]')).forEach(input => input.remove());
    // Add hidden inputs for each selected child variant
    for (const [variantId, qty] of Object.entries(this.selectedVariants)) {
      if (qty > 0) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[_pv${variantId}]`;
        input.value = qty;
        input.setAttribute('data-skio-child-variant', 'true');
        form.appendChild(input);
        // Add hidden input for product title
        const child = this.childProducts.find(c => (c.platformId || c.id) == variantId);
        if (child) {
          const titleInput = document.createElement('input');
          titleInput.type = 'hidden';
          titleInput.name = `properties[${child.productTitle}]`;
          titleInput.value = qty;
          titleInput.setAttribute('data-skio-child-variant', 'true');
          form.appendChild(titleInput);
        }
      }
    }
    this._updateAddToCartButtonState();
  }

  _updateAddToCartButtonState() {
    const form = this.findProductForm();
    if (!form) return;
    const addToCartBtn = form.querySelector('button[type="submit"], [type="submit"]');
    if (!addToCartBtn) return;
    const totalSelected = Object.values(this.selectedVariants).reduce((sum, q) => sum + q, 0);
    const shouldEnable = this.maxQuantity && totalSelected === this.maxQuantity;
    addToCartBtn.disabled = !shouldEnable;
    
  }

  _onProgressBarClick() {
    const totalSelected = Object.values(this.selectedVariants).reduce((sum, q) => sum + q, 0);
    if (this.maxQuantity && totalSelected === this.maxQuantity) {
      const addToCartBtn = document.getElementById('AddToCart');
      if (addToCartBtn) {
        addToCartBtn.click();
      }
    }
  }

  render() {
    if (!this.childProducts.length) {
      return html``;
    }
    
    if (this.loading) {
      return html`<div style="text-align:center;">Loading options...</div>`;
    }
    
    const totalSelected = Object.values(this.selectedVariants).reduce((sum, q) => sum + q, 0);
    const max = this.maxQuantity;
    const percent = max ? Math.min(100, Math.round((totalSelected / max) * 100)) : 0;
    const barClickable = max && totalSelected === max;
    return html`
      <div class="skio-box-progress-bar-wrapper">
        <div class="skio-box-progress-bar-container">
          <div 
            class="skio-box-progress-bar${barClickable ? ' clickable' : ''}"
            style="width: ${percent}%;"
            @click="${barClickable ? this._onProgressBarClick.bind(this) : null}"
            title="${barClickable ? 'Click to add to cart' : 'Select all required items to continue'}"
          ></div>
          ${totalSelected < max ? html`<div class="skio-box-progress-label">Add ${max - totalSelected} to continue</div>` : html`<div class="skio-box-progress-label">Continue</div>`}
        </div>
      </div>
      <div class="skio-box-child-grid">
        ${this.childProducts.map(child => {
          const variantId = child.platformId || child.id;
          const quantity = this.selectedVariants[variantId] || 0;
          const disableUp = max && totalSelected >= max;
          return html`
            <div class="skio-box-child-card">
              <img src="${child.imageSrc}" alt="${child.productTitle}" />
              <div class="skio-box-child-card-title-container">
                <div class="skio-box-child-card-title">${child.productTitle}</div>
                ${child.productVariantTitle && !child.productVariantTitle.includes('Default Title') ? html`<div class="skio-box-child-card-variant-title">${child.productVariantTitle}</div>` : ''}
              </div>
              <div>
                <label>
                  <button type="button" @click="${() => this._changeQuantityBy(child, -1)}">-</button>
                  <input type="number" min="0" step="1" .value="${quantity}" @input="${e => this._onQuantityChange(e, child)}" @change="${e => this._onQuantityChange(e, child)}" />
                  <button type="button" @click="${() => this._changeQuantityBy(child, 1)}" ?disabled="${disableUp}">+</button>
                </label>
              </div>
            </div>
          `;
        })}
      </div>
    `;
  }
}

customElements.define('skio-static-build-a-box', SkioBoxChildProducts);
